import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      alignItems: 'center',
      display: 'flex',
      gap: 8,

      '& input[type="checkbox"]': {
        display: 'none',
      },
    },
  },
  { name: 'GenericCheckbox' },
);
